<template>
  <div>
    <div
      class="button-container mb-3 text-left"
      v-show="selectedList.length > 0"
    >
      <b-button
        class="mr-3"
        type="button"
        variant="danger"
        @click="$emit('click', selectedList)"
        >刪除</b-button
      >
      <b-button class="mr-3" type="button" variant="dark" @click="clearSelected"
        >取消</b-button
      >
    </div>
    <p v-if="!items.length" class="no-data">查無資料</p>
    <b-table
      v-else
      ref="selectableTable"
      :selectable="isSelectable"
      :select-mode="'multi'"
      @row-selected="onRowSelected"
      :fields="fields"
      :items="items"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      sort-icon-left
      sticky-header
      head-variant="dark"
      hover
      small
      striped
    >
      <template v-slot:cell(created_at)="{ item }">
        <span>{{ dayjs(item.created_at).format("YYYY-MM-DD") }}</span>
      </template>
      <template v-slot:cell(title)="{ item }">
        <a @click="$emit('toDetail', item)">{{ item.title }}</a>
      </template>
      <template v-slot:cell(user)="{ item }">
        <span v-if="!item.user">{{ "" }}</span>
        <span v-else>{{ item.user.account }}</span>
      </template>
    </b-table>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import dayjs from "dayjs";
export default {
  props: {
    fields: {
      type: [Array]
    },
    items: {
      type: [Array]
    },
    sortBy: {
      type: String
    },
    sortDesc: {
      type: Boolean,
      default: false
    },
    isSelectable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedList: []
    };
  },
  methods: {
    onRowSelected(items) {
      this.selectedList = items;
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .table tbody .table-active {
  background-color: #bee5eb;
}
::v-deep {
  .table.b-table.table-hover > tbody > tr:hover td,
  .table.b-table.table-hover > tbody > tr:hover th,
  .table.b-table.table-hover > tbody > tr.table-active:hover td,
  .table.b-table.table-hover > tbody > tr.table-active:hover th {
    background-color: #343a40;
    color: #fff;
  }
}

::v-deep .table tbody tr a {
  display: inline-block;
  width: 100%;
  cursor: pointer;
}
.no-data {
  text-align: center;
}
</style>
